/**
 * Minimaler Hoehen-Sync fuer den eingebetteten iframe waehrend der Skeleton-Phase.
 * Verhindert (v.a. in Safari) einen kollabierten iframe, bis der Monolith seinen
 * eigenen, kontinuierlichen Sync uebernimmt.
 */

function isEmbedded(): boolean {
    try {
        return window.parent !== window;
    } catch {
        return true;
    }
}

function postHeight(): void {
    try {
        // Gleiche Messbasis wie der Monolith (measureRegistrationEmbedHeight):
        // im Embed bevorzugt #mainContent, damit beim Skeleton->Monolith-Uebergang
        // kein Hoehensprung entsteht. Floor 400 identisch zum Monolith-Bootstrap.
        const main = document.getElementById('mainContent');
        let height = 0;
        if (main && main.childElementCount > 0) {
            height = Math.max(main.scrollHeight, main.offsetHeight);
        }
        if (height < 80) {
            const doc = document.documentElement;
            const body = document.body;
            height = Math.max(
                doc ? doc.scrollHeight : 0,
                body ? body.scrollHeight : 0,
            );
        }
        height = Math.max(height, 400);
        window.parent.postMessage({ action: 'iframeHeight', iframeHeight: height }, '*');
    } catch {
        /* ignore */
    }
}

let timer: number | null = null;

/** Startet einen kurzen Intervall-Sync (Safari-sicher), der stoppt sobald Monolith laeuft. */
export function startDisplayHeightSync(): void {
    if (!isEmbedded() || timer != null) return;
    postHeight();
    const started = Date.now();
    timer = window.setInterval(() => {
        // Monolith uebernimmt -> eigener Sync aktiv: eigenen Intervall beenden.
        if ((globalThis as { bootRegistrationApp?: unknown }).__vivMonolithBooted === true || Date.now() - started > 12000) {
            stopDisplayHeightSync();
            return;
        }
        postHeight();
    }, 300);
}

export function stopDisplayHeightSync(): void {
    if (timer != null) {
        window.clearInterval(timer);
        timer = null;
    }
}

// Globaler Stopp-Hook, damit der Monolith den fruehen Sync sofort beenden kann
// (statt bis zu einem Interval-Tick zu warten) und keine zwei Reporter kollidieren.
(globalThis as { __vivStopDisplayHeightSync?: () => void }).__vivStopDisplayHeightSync = stopDisplayHeightSync;
